import { useEffect, useRef, useState } from 'react';
import CryptoJS from 'crypto-js';
import { Box, Spacer, Text, VStack, useMediaQuery } from 'native-base';
import { useSelector, useDispatch } from 'react-redux';
import Svg from 'react-native-svg';
import LandingPageBanner from './banner';
import LandingPageEvents from './events';
import { COLORS } from '../../utils/colors';
import QuickLinks from './quickLinks';
import CustomModal from '../../components/modal';
import CustomButton from '../../components/button';
import ProgressStepsBar from '../../components/progressStepsBar';
import EventBasicDetails from './eventRequestFlow/basicDetail';
import { MOBILE_VIEW_WIDTH } from '../../utils/screens';
import EventDetails from './eventRequestFlow/eventDetail';
import UploadPeople from './eventRequestFlow/uploadPeople';
import Attachments from './eventRequestFlow/attachments';
import MiceBasicDetails from './miceRequestFlow/basicDetail';
import MiceDetails from './miceRequestFlow/miceDetail';
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from '../../utils/fonts';
import {
  changeEventStep,
  changeMiceStep
} from '../../store/reducers/eventSlice';
import QuickLinksDetailsPage from '../quickLinkDetailsPage';
import MobileHeader from '../../layout/header/mobileHeader';
import WebHeader from '../../layout/header/webHeader';
import { eventErrorPayload, miceErrorPayload } from '../../utils/payload';
import { eventFormValidator, miceFormValidator } from '../../utils/validator';
import { Toaster } from '../../components/toaster';
import { hasPermission } from '../../utils/permission';
import { contactAdminSVG } from '../../utils/svg';
import {
  getSchemaAPI,
  getSchemaDetailsAPI,
  getWorkflowAPI,
  uploadFileAPI
} from '../../api/apis/workflow';
import { schemaExtractor } from '../../utils/schemaExtractor';
import {
  checkEventNameAPI,
  checkValidAttendeesUpload,
  createEventAPI,
  newEventListingAPI
} from '../../api/apis/event';
import { getBlockedTravelPartners } from '../../api/apis/quicklinks';
import { emailValidator } from '../../utils/validator';
import MobileModelSheet from '../../components/actionSheet';
import { LoaderAnimation } from '../../components/spinner';
import VendorLandingPageEvents from './vendorEvents';
import PackagesListingPage from '../packagesListingPage';
import CommonHeading from '../../components/headings';
import { PackagesCard } from '../../containers/packages';
import CventMobileLandingPageBanner from './banner/cventMobileBanner';
import CventWebLandingPageBanner from './banner/cventWebBanner';
import config from '../../utils/config';
import QuickMeetListingPage from '../quickMeetDetailPage';
import { getHotelListAPI } from '../../api/apis/quicklinks';

const LandingPage = () => {
  const dispatch = useDispatch();
  const toaster = Toaster();
  const childref = useRef(null);
  const childRef = useRef(null);
  const bytes = CryptoJS.AES.decrypt(
    sessionStorage.getItem('content'),
    config.userKey
  );
  const jsonString = bytes.toString(CryptoJS.enc.Utf8);
  const userInfo = JSON.parse(jsonString);
  const { activeEventStep, activeMiceStep, activeTab } = useSelector(
    (state) => {
      return state.event;
    }
  );
  const eventTab = activeTab === 'event' ? 'Event' : 'MICE';
  const [hotelList, setHotelList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [tabActiveButton, setTabActiveButton] = useState('upcoming');
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH
  });
  const [events, setEvents] = useState([]);
  const [workflow, setWorkflow] = useState({});
  const [eventFormData, setEventFormData] = useState({});
  const [miceFormData, setMiceFormData] = useState({});
  const [eventErrorFormData, setErrorEventFormData] =
    useState(eventErrorPayload);
  const [miceErrorFormData, setErrorMiceFormData] = useState(miceErrorPayload);
  const [quickLink, setQuickLink] = useState(false);
  const [selectedLink, setSelectedLink] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [currentEventStep, setCurrentEventStep] = useState(activeEventStep);
  const [currentMiceStep, setCurrentMiceStep] = useState(activeMiceStep);
  const [eventAgency, setEventAgency] = useState([]);
  const [miceAgency, setMiceAgency] = useState([]);
  const [extracted, setExtracted] = useState([]);
  const [pagination, setPagination] = useState(0);
  const totalSteps = 4;
  const stepNames = [
    'Basic Details',
    `${eventTab} Details`,
    'Attendees',
    'Documents'
  ];
  const [defaultData, setDefaultData] = useState({});
  const [forceRemount, setForceRemount] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!hasPermission('VENDOR')) AddWorkflow();
  }, [activeTab]);

  useEffect(() => {
    if (activeTab === 'meet') {
      const fetchHotelList = async () => {
        const response = await getHotelListAPI(
          '', // hotel_name
          '', // city
          '', // number_of_participants
          '', // rate
          '', // search
          1, // page
          10 // per_page
        );
        if (!response.error) {
          setHotelList(response.data.data.data.hotel_data);
        }
      };

      fetchHotelList();
    }
  }, [activeTab]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const showToaster = (message) => {
    toaster(
      message || "You've selected this agency 3 times, please choose another agency",
      'error',
      'error'
    );
  };

  function addTimeAndFormat() {
    const now = new Date();

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    const milliseconds = String(now.getMilliseconds()).padStart(3, '0');

    const formattedMilliseconds = milliseconds.padEnd(6, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${formattedMilliseconds}`;
  }

  const AddWorkflow = async () => {
    let res = await getWorkflowAPI();
    if (res.error) {
      toaster(res.message, 'error', 'error');
      return;
    } else {
      let workflows = {};
      res.data.data.data?.map((item) => {
        if (item.name === 'EventWorkflow') {
          workflows['event'] = item;
        }
        if (item.name === 'ImageWorkflow') {
          workflows['image'] = item;
        }
        if (item.name === 'ReviewWorkflow') {
          workflows['review'] = item;
        }
      });
      setWorkflow(workflows);
      getSchema();
      if (hasPermission('AGENCY')) {
        getAgencies();
      }
      if (workflows && workflows['event'] && workflows['event']['_id'])
        getEventList();
    }
  };

  const getEventList = async (
    status = tabActiveButton,
    page_no = 1,
    per_page = 10,
    user_id = '',
    add = true
  ) => {
    if (status === 'deleted') {
      setIsLoading(false);
      return [];
    }
    setIsLoading(true);
    if (userInfo.role !== 'admin') {
      user_id = userInfo.email;
    }
    let res = await newEventListingAPI(
      activeTab,
      page_no,
      per_page,
      status,
      user_id,
      'home'
    );
    if (res.error) {
      toaster(res.message, 'error', 'error');
      return [];
    } else {
      if (add) {
        setEvents(res.data.data.data?.[0]?.events);
      } else if (!add) {
        setEvents([...events, ...res.data.data.data?.[0]?.events]);
      }
      setCurrentPage(res.data.data.data?.[0]?.pagination?.[0]?.page + 1);
      setPagination(res.data.data.data?.[0]?.pagination?.[0]?.total);
      setIsLoading(false);
      return res.data.data.data?.[0]?.events;
    }
  };

  const getSchema = async () => {
    let documentSchema = '';
    let res = await getSchemaAPI();
    if (res.error) {
      toaster(res.message, 'error', 'error');
      return;
    } else {
      res &&
        res.data.data.data &&
        res.data.data.data.map((item) => {
          if (item.title === 'CREATE_EVENT') {
            documentSchema = item._id;
          }
        });
    }

    if (documentSchema) {
      let res = await getSchemaDetailsAPI(documentSchema);
      if (res.error) {
        toaster(res.message, 'error', 'error');
        return;
      } else {
        let extracted = schemaExtractor(res.data.data.data.properties);
        setDefaultData(schemaExtractor(res.data.data.data.properties));
        setExtracted(extracted);
        setEventFormData(extracted);
        setMiceFormData(extracted);
      }
    }
  };

  const handleLinksSelect = (selectlink) => {
    setQuickLink(!quickLink);
    setSelectedLink(selectlink);
  };

  const handleEventStepChange = (step) => {
    dispatch(changeEventStep(step));
    setCurrentEventStep(step);
  };

  const handleMiceStepChange = (step) => {
    dispatch(changeMiceStep(step));
    setCurrentMiceStep(step);
  };

  const openModal = () => {
    if (hasPermission('AGENCY')) {
      getAgencies();
    }
    MobileWindow && childRef.current.scrollToTop();
    setForceRemount(!forceRemount);
    scrollToTop();
    setShowModal(true);
  };

  const setDefaultErrorFrom = () => {
    setErrorEventFormData(eventErrorPayload);
    setErrorMiceFormData(miceErrorPayload);
  };

  const closeModal = () => {
    setForceRemount(!forceRemount);
    setShowModal(false);
    setCurrentEventStep(0);
    setCurrentMiceStep(0);
    dispatch(changeEventStep(0));
    dispatch(changeMiceStep(0));
    setEventFormData(defaultData);
    setMiceFormData({
      additional_info: {
        boarding_from: '',
        conference_location: '',
        destination_to: '',
        hotel_requirement: '',
        number_of_nights: '',
        number_of_persons: '',
        service_required: []
      },
      agency: [],
      quiz_id: '',
      is_premium: '',
      business: '',
      banner: '',
      coordinator_name: '',
      coordinator_name_2: '',
      coordinator_name_3: '',
      current_step: '',
      documents: [],
      email: '',
      email_2: '',
      email_3: '',
      employee: [],
      estimated_budget: '',
      event_location: '',
      event_name: '',
      from_date: '',
      metadata: {},
      other_requirements: '',
      about_event: '',
      phone: '',
      phone_2: '',
      phone_3: '',
      status: '',
      to_date: '',
      type: '',
      workflow_id: ''
    });
    setErrorEventFormData(eventErrorPayload);
    setErrorMiceFormData(miceErrorPayload);
  };

  const uploadFilesToServer = async (data, type) => {
    let docs = [];
    if (type === 'documents') {
      let res = await uploadFileAPI(data, undefined, 'document');

      res.map((item) => {
        if (item.error) {
          toaster('Upload file failed', 'error', 'error');
          return;
        }
        if (item.data.data.data) {
          docs.push({
            doc_type: item.data.data.data.doc_type,
            file_size: item.data.data.data.file_size.toString(),
            file_name: item.data.data.data.file_name,
            uploaded_time: getStartDateFormat(new Date())
          });
        }
      });
    }
    if (type === 'employee') {
      let res = await uploadFileAPI(data, 'file', 'people');

      res.map((item) => {
        if (item.error) {
          toaster('Upload file failed', 'error', 'error');
          return;
        }
        if (item.data.data.data) {
          docs.push(item.data.data.data);
        }
      });
    }
    if (type === 'banner') {
      if (data && data.length && data.length > 0) {
        let res = await uploadFileAPI(data, 'image', 'image');

        res &&
          res.map((item) => {
            if (item.error) {
              toaster('Upload file failed', 'error', 'error');
              return;
            }
            if (item.data.data.data) {
              docs.push({
                doc_type: item.data.data.data.doc_type,
                file_size: item.data.data.data.file_size.toString(),
                file_name: item.data.data.data.file_name,
                uploaded_time: getStartDateFormat(new Date())
              });
            }
          });
      }
    }
    if (type === 'logo') {
      if (data && data.length && data.length > 0) {
        let res = await uploadFileAPI(data, 'image', 'image');

        if (res && Array.isArray(res)) {
          res.map((item) => {
            if (item && item.error) {
              toaster('Upload file failed', 'error', 'error');
              return;
            }
            if (item && item.data && item.data.data && item.data.data.data) {
              docs.push({
                doc_type: item.data.data.data.doc_type,
                file_size: item.data.data.data.file_size.toString(),
                file_name: item.data.data.data.file_name,
                uploaded_time: getStartDateFormat(new Date())
              });
            }
          });
        }
      }
    }

    return docs;
  };

  const getStartDateFormat = (dateString, type = 'start') => {
    const date = new Date(dateString);
    function padTo2Digits(num) {
      return num.toString().padStart(2, '0');
    }

    function formatDate(date, type) {
      let hours, minutes, seconds;
      if (type === 'start') {
        hours = minutes = seconds = '00';
      } else if (type === 'end') {
        hours = '23';
        minutes = '59';
        seconds = '00';
      } else {
        hours = padTo2Digits(date.getHours());
        minutes = padTo2Digits(date.getMinutes());
        seconds = padTo2Digits(date.getSeconds());
      }

      return (
        [
          date.getFullYear(),
          padTo2Digits(date.getMonth() + 1),
          padTo2Digits(date.getDate())
        ].join('-') +
        'T' +
        [hours, minutes, seconds].join(':') +
        '.616838+00:00'
      );
    }

    const formattedDate = formatDate(date, type);

    return formattedDate;
  };

  const handleDaysCalculation = (starts_at, ends_at, type) => {
    const fromDate = new Date(starts_at);
    const toDate = new Date(ends_at);
    const differenceInDays =
      Math.ceil((toDate - fromDate) / (1000 * 60 * 60 * 24)) + 1;
    let options = [];
    let days = [];

    for (var i = 0; i < differenceInDays; i++) {
      options.push(`Day ${i + 1}`);
      const key = `Day ${i + 1}`;
      days.push({
        [key]: {
          agenda: [
          {
            type: '',
            title: '',
            start_time: '',
            end_time: '',
            location: '',
            speaker_name: '',
            speaker_designation: '',
            speaker_topic: '',
            speaker_details: '',
            file_name: '',
            description: '',
          },
        ],
          menu: [{ title: '', list: [] }],
          status: ''
        }
      });
    }
    return days;
  };

  const onCreateRequest = async () => {
    LoaderAnimation.show();
    if (activeTab === 'event') {
      if (
        !eventFormValidator(
          eventFormData,
          eventErrorFormData,
          setErrorEventFormData
        )
      ) {
      } else {
        setEventFormData(eventFormData);
        toaster('Enter all the details correctly', 'error', 'error');
        LoaderAnimation.hide();
        return;
      }

      let payload = { ...eventFormData };
      if (eventFormData.documents.length > 0) {
        let docs = await uploadFilesToServer(
          eventFormData.documents,
          'documents'
        );
        payload.documents = docs;
      }
      if (eventFormData.employee.length > 0) {
        let docs = await uploadFilesToServer(
          eventFormData.employee,
          'employee'
        );
        payload.employee = [];
        payload.employee_file_path = docs;
      }
      if (eventFormData.banner !== '') {
        let docs = await uploadFilesToServer(eventFormData.banner, 'banner');
        payload.banner = docs;
      } else if (eventFormData.banner === '') {
        payload.banner = [];
      }
      if (eventFormData.logo && eventFormData.logo.length > 0) {
        let docs = await uploadFilesToServer(eventFormData.logo, 'logo');
        payload.logo = docs;
      } else {
        payload.logo = [];
      }
      payload['type'] = 'event';
      payload['starts_at'] = getStartDateFormat(payload['from_date'], 'start');
      payload['ends_at'] = getStartDateFormat(payload['to_date'], 'end');
      payload['contact_details'] = {
        coordinator_name: payload.coordinator_name,
        phone: payload.phone,
        email: payload.email,
        coordinator_name_2: payload.coordinator_name_2,
        phone_2: payload.phone_2,
        email_2: payload.email_2,
        coordinator_name_3: payload.coordinator_name_3,
        phone_3: payload.phone_3,
        email_3: payload.email_3
      };
      let agencyStructure = [];
      if (payload.self_agency_approval) {
        payload.agency = [];
      } else {
        payload.agency &&
          payload.agency.map((item) => {
            agencyStructure.push({
              id: item.value,
              name: item.label,
              status: 'null',
              emailId: item.emailId
            });
          });
        payload.agency = agencyStructure;
      }

      let breakdown = handleDaysCalculation(
        payload['starts_at'],
        payload['ends_at']
      );
      payload.event_break_down = breakdown;

      delete payload['additional_info'];
      delete payload['current_step'];
      delete payload['metadata'];
      delete payload['status'];
      delete payload['workflow_id'];
      delete payload['quiz_title']

      payload.approved_at = '';
      payload.added_at = addTimeAndFormat();

      let postData = {
        instance: [payload]
      };
      let eventRes = await createEventAPI(
        workflow['event']['_id'],
        'EVENT_REQUEST',
        postData
      );
      if (eventRes.error) {
        toaster(eventRes.message, 'error', 'error');
        LoaderAnimation.hide();
        return;
      } else {
        toaster('Event Created Successfully', 'success', 'success');
        getEventList();
        closeModal();
      }
    }

    if (activeTab === 'mice') {
      if (
        !miceFormValidator(
          miceFormData,
          miceErrorFormData,
          setErrorMiceFormData
        )
      ) {
      } else {
        setMiceFormData(miceFormData);
        toaster('Enter all the details correctly', 'error', 'error');
        LoaderAnimation.hide();
        return;
      }

      let payload = { ...miceFormData };
      if (miceFormData.documents.length > 0) {
        let docs = await uploadFilesToServer(
          miceFormData.documents,
          'documents'
        );
        payload.documents = docs;
      }
      if (miceFormData.employee.length > 0) {
        let docs = await uploadFilesToServer(miceFormData.employee, 'employee');
        payload.employee = [];
        payload.employee_file_path = docs;
      }
      if (miceFormData.banner !== '') {
        let docs = await uploadFilesToServer(miceFormData.banner, 'banner');
        payload.banner = docs;
      } else if (miceFormData.banner === '') {
        payload.banner = [];
      }

      payload['type'] = 'mice';
      payload['starts_at'] = getStartDateFormat(payload['from_date'], 'start');
      payload['ends_at'] = getStartDateFormat(payload['to_date'], 'end');
      payload['contact_details'] = {
        coordinator_name: payload.coordinator_name,
        phone: payload.phone,
        email: payload.email,
        coordinator_name_2: payload.coordinator_name_2,
        phone_2: payload.phone_2,
        email_2: payload.email_2,
        coordinator_name_3: payload.coordinator_name_3,
        phone_3: payload.phone_3,
        email_3: payload.email_3
      };
      let agencyStructure = [];
      if (payload.self_agency_approval) {
        payload.agency = [];
      } else {
        payload.agency &&
          payload.agency.map((item) => {
            agencyStructure.push({
              id: item.value,
              name: item.label,
              status: 'null',
              emailId: item.emailId
            });
          });
        payload.agency = agencyStructure;
      }
      let serviceStructure = [];
      payload.additional_info.service_required &&
        payload.additional_info.service_required.map((item) => {
          serviceStructure.push(item.value);
        });
      payload.additional_info.service_required = serviceStructure;

      let breakdown = handleDaysCalculation(
        payload['starts_at'],
        payload['ends_at']
      );
      payload.event_break_down = breakdown;

      delete payload['current_step'];
      delete payload['metadata'];
      delete payload['status'];
      delete payload['workflow_id'];
      delete payload['quiz_title']

      payload.approved_at = '';
      payload.added_at = addTimeAndFormat();

      let postData = {
        instance: [payload]
      };

      let eventRes = await createEventAPI(
        workflow['event']['_id'],
        'EVENT_REQUEST',
        postData
      );
      if (eventRes.error) {
        toaster(eventRes.message, 'error', 'error');
        LoaderAnimation.hide();
        return;
      } else {
        toaster('MICE Created Successfully', 'success', 'success');
        getEventList();
        closeModal();
      }
    }
    LoaderAnimation.hide();
  };

  const handleSteps = async (type) => {
    if (activeTab === 'mice') {
      if (type === 'next') {
        let basiceventData = {},
          eventdetialData = {};
        if (currentMiceStep === 0) {
          basiceventData = childref.current.onSubmitDataInput();
          basiceventData.business = userInfo?.company;
          basiceventData.coordinator_name = userInfo?.display_name;
          basiceventData.email = userInfo?.email;
          let error = false;
          let errorMessage = { ...miceErrorFormData };
          if (basiceventData.additional_info.conference_location === '') {
            error = true;
            errorMessage['conference_location'] =
              'Please Select Conference Location';
          }
          if (basiceventData.additional_info.hotel_requirement === '') {
            error = true;
            errorMessage['hotel_requirement'] =
              'Please select Hotel Requirement';
          }
        //   if (basiceventData.is_premium === '' || basiceventData.is_premium === null || basiceventData.is_premium === undefined) {
        //   error = true;
        //   errorMessage['is_premium'] = 'Please select Premium Booking or Not';
        // }
        // if (basiceventData.quiz_id === '') {
        //   error = true;
        //   errorMessage['quiz_id'] = 'Please select Quiz Id';
        // }
          if (!basiceventData?.self_agency_approval) {
            if (
              basiceventData.agency === '' ||
              basiceventData.agency.length === 0
            ) {
              error = true;
              errorMessage['agency'] = 'Please select Agencies';
            }
            if (
              basiceventData.agency.length > 0 &&
              basiceventData.agency.length < 3
            ) {
              error = true;
              errorMessage['agency'] = 'Please select minimum 3 Agencies';
            }
          }
          if (basiceventData.business === '') {
            error = true;
            errorMessage['business'] = 'Please enter Business Name';
          } else if (
            basiceventData.business.length < 3 ||
            !/^(?!\s)(?=.*[A-Za-z])[A-Za-z0-9!@#$%^&*()-_+=<>?\s]*$/.test(
              basiceventData.business
            )
          ) {
            error = true;
            errorMessage['business'] = 'Please enter proper Business Name';
          } else if (basiceventData.business.length > 500) {
            error = true;
            errorMessage['business'] =
              'Please enter Business Name less than 500 characters';
          }

          if (basiceventData.coordinator_name === '') {
            error = true;
            errorMessage['coordinator_name'] =
              'Please enter Coordinator Name 1';
          } else if (
            basiceventData.coordinator_name.length < 3 ||
            !/^(?!\s)(?=.*[A-Za-z])[A-Za-z0-9!@#$%^&*()-_+=<>?\s]*$/.test(
              basiceventData.coordinator_name
            )
          ) {
            error = true;
            errorMessage['coordinator_name'] =
              'Please enter proper Coordinator Name 1';
          } else if (basiceventData.coordinator_name.length > 500) {
            error = true;
            errorMessage['coordinator_name'] =
              'Please enter Coordinator Name 1 less than 500 characters';
          }

          if (basiceventData.coordinator_name_2 !== '') {
            if (
              basiceventData.coordinator_name_2.length < 3 ||
              !/^(?!\s)(?=.*[A-Za-z])[A-Za-z0-9!@#$%^&*()-_+=<>?\s]*$/.test(
                basiceventData.coordinator_name_2
              )
            ) {
              error = true;
              errorMessage['coordinator_name_2'] =
                'Please enter proper Coordinator Name 2';
            } else if (basiceventData.coordinator_name_2.length > 500) {
              error = true;
              errorMessage['coordinator_name_2'] =
                'Please enter Coordinator Name 2 less than 500 characters';
            }
          }
          if (
            basiceventData.email_2 !== '' &&
            !emailValidator(basiceventData.email_2)
          ) {
            error = true;
            errorMessage['email_2'] = 'Please enter valid Email ID 2';
          }
          if (
            basiceventData.phone_2 !== '' &&
            basiceventData.phone_2.length !== 10
          ) {
            error = true;
            errorMessage['phone_2'] = 'Please enter 10 digit Contact Number 2';
          }

          if (basiceventData.coordinator_name_3 !== '') {
            if (
              basiceventData.coordinator_name_3.length < 3 ||
              !/^(?!\s)(?=.*[A-Za-z])[A-Za-z0-9!@#$%^&*()-_+=<>?\s]*$/.test(
                basiceventData.coordinator_name_3
              )
            ) {
              error = true;
              errorMessage['coordinator_name_3'] =
                'Please enter proper Coordinator Name 3';
            } else if (basiceventData.coordinator_name_3.length > 500) {
              error = true;
              errorMessage['coordinator_name_3'] =
                'Please enter Coordinator Name 3 less than 500 characters';
            }
          }
          if (
            basiceventData.email_3 !== '' &&
            !emailValidator(basiceventData.email_3)
          ) {
            error = true;
            errorMessage['email_3'] = 'Please enter valid Email ID 3';
          }
          if (
            basiceventData.phone_3 !== '' &&
            basiceventData.phone_3.length !== 10
          ) {
            error = true;
            errorMessage['phone_3'] = 'Please enter 10 digit Contact Number 3';
          }

          if (
            basiceventData.additional_info.boarding_from !== '' &&
            basiceventData.additional_info.boarding_from.length < 3
          ) {
            error = true;
            errorMessage['boarding_from'] = 'Please enter proper Boarding From';
          } else if (
            basiceventData.additional_info.boarding_from !== '' &&
            basiceventData.additional_info.boarding_from.length > 3 &&
            basiceventData.additional_info.boarding_from.length > 500
          ) {
            error = true;
            errorMessage['boarding_from'] =
              'Please enter Boarding From less than 500 characters';
          }
          if (
            basiceventData.additional_info.destination_to !== '' &&
            basiceventData.additional_info.destination_to.length < 3
          ) {
            error = true;
            errorMessage['destination_to'] =
              'Please enter proper Destination To';
          } else if (
            basiceventData.additional_info.destination_to !== '' &&
            basiceventData.additional_info.destination_to.length > 3 &&
            basiceventData.additional_info.destination_to.length > 500
          ) {
            error = true;
            errorMessage['destination_to'] =
              'Please enter Destination To less than 500 characters';
          }
          if (basiceventData.email === '') {
            error = true;
            errorMessage['email'] = 'Please enter Email ID 1';
          }
          if (
            basiceventData.other_requirements !== '' &&
            basiceventData.other_requirements.length > 0 &&
            basiceventData.other_requirements.length > 5000
          ) {
            error = true;
            errorMessage['other_requirements'] =
              'Please enter Other Requirements less than 5000 characters';
          }
          if (
            basiceventData.phone !== '' &&
            basiceventData.phone.length !== 10
          ) {
            error = true;
            errorMessage['phone'] = 'Please enter 10 digit Contact Number 1';
          }
          if (!emailValidator(basiceventData.email)) {
            error = true;
            errorMessage['email'] = 'Please enter valid Email ID 1';
          }
          if (error) {
            setErrorMiceFormData(errorMessage);
            toaster('Please enter proper data', 'error', 'error');
            return;
          }
          MobileWindow && childRef.current.scrollToTop();
          scrollToTop();
          let data = { ...miceFormData };
          Object.keys(basiceventData).map((key) => {
            data[key] = basiceventData[key];
          });
          setMiceFormData(data);
        }
        if (currentMiceStep === 1) {
          eventdetialData = childref.current.onSubmitDataInput();
          let error = false;
          let errorMessage = { ...miceErrorFormData };
          if (
            eventdetialData.additional_info.service_required === '' ||
            eventdetialData.additional_info.service_required.length === 0
          ) {
            error = true;
            errorMessage['service_required'] = 'Please select Service Type';
          }
          if (eventdetialData.event_name === '') {
            error = true;
            errorMessage['event_name'] = 'Please enter MICE Name';
          } else if (
            eventdetialData.event_name.length < 3 ||
            !/^(?!\s)(?=.*[A-Za-z])[A-Za-z0-9!@#$%^&*()-_+=<>?\s]*$/.test(
              eventdetialData.event_name
            )
          ) {
            error = true;
            errorMessage['event_name'] = 'Please enter proper MICE Name';
          } else if (eventdetialData.event_name.length > 500) {
            error = true;
            errorMessage['event_name'] =
              'Please enter MICE Name less than 500 characters';
          }
          if (eventdetialData.event_name !== '') {
            let eventExist = await checkEventNameAPI(
              eventdetialData.event_name
            );
            if (!eventExist?.data?.data?.data?.exists) {
              error = true;
              errorMessage['event_name'] = 'MICE Name already exists';
            }
          }

          if (
            eventdetialData.event_location !== '' &&
            /https?:\/\//.test(eventdetialData.event_location)
              ? !(
                  /^https?:\/\/(www\.)?google\.com\/maps\/(place\/|\?)/.test(
                    eventdetialData.event_location
                  ) ||
                  /^https?:\/\/maps\.app\.goo\.gl\/[A-Za-z0-9]+$/.test(
                    eventdetialData.event_location
                  ) ||
                  /^https:\/\/www\.google\.com\/search\?q=[^&]+(&[^#]*)?(#.+)?$/.test(
                    eventdetialData.event_location
                  )
                )
              : !/^[^<>~"`{}\\]*$/.test(eventdetialData.event_location)
          ) {
            error = true;
            errorMessage['event_location'] =
              'Please enter proper MICE Location';
          }
          if (
            eventdetialData.event_location !== '' &&
            !/https?:\/\//.test(eventdetialData.event_location) &&
            eventdetialData.event_location.length > 10
          ) {
            error = true;
            errorMessage['event_location'] =
              'Please enter MICE Location less than 500 characters';
          }

          if (eventdetialData.from_date === '') {
            error = true;
            errorMessage['from_date'] = 'Please enter MICE From Date';
          }
          if (eventdetialData.to_date === '') {
            error = true;
            errorMessage['to_date'] = 'Please enter MICE To Date';
          }
          if (
            eventdetialData.additional_info.hotel_requirement ===
              'with_hotel' &&
            eventdetialData.additional_info.number_of_nights === ''
          ) {
            error = true;
            errorMessage['number_of_nights'] = 'Please enter Number of Nights';
          }
          if (
            eventdetialData.about_event !== '' &&
            eventdetialData.about_event.length > 0 &&
            eventdetialData.about_event.length > 5000
          ) {
            error = true;
            errorMessage['about_event'] =
              'Please enter About MICE less than 5000 characters';
          }
          if (error) {
            setErrorMiceFormData(errorMessage);
            toaster('Please enter proper data', 'error', 'error');
            return;
          }
          MobileWindow && childRef.current.scrollToTop();
          scrollToTop();
          let data = { ...miceFormData };
          Object.keys(eventdetialData).map((key) => {
            data[key] = eventdetialData[key];
          });
          setMiceFormData(data);
        }

        if (currentMiceStep === 2 && miceFormData?.employee.length > 0) {
          if (miceFormData?.employee?.[0]?.lastModified) {
            let postData = new FormData();
            postData.append('file', miceFormData?.employee?.[0]);
            let res = await checkValidAttendeesUpload(postData);
            if (res.error) {
              toaster(res.message, 'error', 'error');
              return;
            }
          }
        }

        handleMiceStepChange(currentMiceStep + 1);
      }
      if (type === 'back') {
        MobileWindow && childRef.current.scrollToTop();
        scrollToTop();
        if (currentMiceStep === 1) {
          let stepData = childref.current.onSubmitDataInput();
          let data = { ...miceFormData };
          Object.keys(stepData).map((key) => {
            data[key] = stepData[key];
          });
          setMiceFormData(data);
        }
        handleMiceStepChange(currentMiceStep - 1);
      }
    }
    if (activeTab === 'event') {
      if (type === 'next') {
        if (currentEventStep === 0) {
          let basiceventData = childref.current.onSubmitDataInput();
          basiceventData.business = userInfo.company
            ? userInfo.company
            : basiceventData.business;
          basiceventData.coordinator_name = userInfo.display_name
            ? userInfo.display_name
            : basiceventData.display_name;
          basiceventData.email = userInfo.email
            ? userInfo.email
            : basiceventData.email;
          let error = false;
          let errorMessage = { ...eventErrorFormData };
          if (!basiceventData?.self_agency_approval) {
            if (
              basiceventData.agency === '' ||
              basiceventData.agency.length === 0
            ) {
              error = true;
              errorMessage['agency'] = 'Please select Agencies';
            }
            if (
              basiceventData.agency.length > 0 &&
              basiceventData.agency.length < 3
            ) {
              error = true;
              errorMessage['agency'] = 'Please select minimum 3 Agencies';
            }
          }
           // if (basiceventData.is_premium === '' || basiceventData.is_premium === null || basiceventData.is_premium === undefined) {
          // error = true;
          // errorMessage['is_premium'] = 'Please select Premium or Not';
        // }
        // if (basiceventData.quiz_id === '') {
        //   error = true;
        //   errorMessage['quiz_id'] = 'Please select Quiz Id';
        // }
          if (basiceventData.business === '') {
            error = true;
            errorMessage['business'] = 'Please enter Business Name';
          } else if (
            basiceventData.business.length < 3 ||
            !/^(?!\s)(?=.*[A-Za-z])[A-Za-z0-9!@#$%^&*()-_+=<>?\s]*$/.test(
              basiceventData.business
            )
          ) {
            error = true;
            errorMessage['business'] = 'Please enter proper Business Name';
          } else if (basiceventData.business.length > 500) {
            error = true;
            errorMessage['business'] =
              'Please enter Business Name less than 500 characters';
          }
          if (basiceventData.coordinator_name === '') {
            error = true;
            errorMessage['coordinator_name'] =
              'Please enter Coordinator Name 1';
          } else if (
            basiceventData.coordinator_name.length < 3 ||
            !/^(?!\s)(?=.*[A-Za-z])[A-Za-z0-9!@#$%^&*()-_+=<>?\s]*$/.test(
              basiceventData.coordinator_name
            )
          ) {
            error = true;
            errorMessage['coordinator_name'] =
              'Please enter proper Coordinator Name 1';
          } else if (basiceventData.coordinator_name.length > 500) {
            error = true;
            errorMessage['coordinator_name'] =
              'Please enter Coordinator Name 1 less than 500 characters';
          }
          if (basiceventData.email === '') {
            error = true;
            errorMessage['email'] = 'Please enter Email ID 1';
          }
          if (!emailValidator(basiceventData.email)) {
            error = true;
            errorMessage['email'] = 'Please enter valid Email ID 1';
          }
          if (
            basiceventData.phone !== '' &&
            basiceventData.phone.length !== 10
          ) {
            error = true;
            errorMessage['phone'] = 'Please enter 10 digit Contact Number 1';
          }

          if (basiceventData.coordinator_name_2 !== '') {
            if (
              basiceventData.coordinator_name_2.length < 3 ||
              !/^(?!\s)(?=.*[A-Za-z])[A-Za-z0-9!@#$%^&*()-_+=<>?\s]*$/.test(
                basiceventData.coordinator_name_2
              )
            ) {
              error = true;
              errorMessage['coordinator_name_2'] =
                'Please enter proper Coordinator Name 2';
            } else if (basiceventData.coordinator_name_2.length > 500) {
              error = true;
              errorMessage['coordinator_name_2'] =
                'Please enter Coordinator Name 2 less than 500 characters';
            }
          }
          if (
            basiceventData.email_2 !== '' &&
            !emailValidator(basiceventData.email_2)
          ) {
            error = true;
            errorMessage['email_2'] = 'Please enter valid Email ID 2';
          }
          if (
            basiceventData.phone_2 !== '' &&
            basiceventData.phone_2.length !== 10
          ) {
            error = true;
            errorMessage['phone_2'] = 'Please enter 10 digit Contact Number 2';
          }

          if (basiceventData.coordinator_name_3 !== '') {
            if (
              basiceventData.coordinator_name_3.length < 3 ||
              !/^(?!\s)(?=.*[A-Za-z])[A-Za-z0-9!@#$%^&*()-_+=<>?\s]*$/.test(
                basiceventData.coordinator_name_3
              )
            ) {
              error = true;
              errorMessage['coordinator_name_3'] =
                'Please enter proper Coordinator Name 3';
            } else if (basiceventData.coordinator_name_3.length > 500) {
              error = true;
              errorMessage['coordinator_name_3'] =
                'Please enter Coordinator Name 3 less than 500 characters';
            }
          }
          if (
            basiceventData.email_3 !== '' &&
            !emailValidator(basiceventData.email_3)
          ) {
            error = true;
            errorMessage['email_3'] = 'Please enter valid Email ID 3';
          }
          if (
            basiceventData.phone_3 !== '' &&
            basiceventData.phone_3.length !== 10
          ) {
            error = true;
            errorMessage['phone_3'] = 'Please enter 10 digit Contact Number 3';
          }

          if (error) {
            setErrorEventFormData(errorMessage);
            toaster('Please enter proper data', 'error', 'error');
            return;
          }
          MobileWindow && childRef.current.scrollToTop();
          scrollToTop();
          let data = { ...eventFormData };
          Object.keys(basiceventData).map((key) => {
            data[key] = basiceventData[key];
          });
          setEventFormData(data);
        }

        if (currentEventStep === 1) {
          let eventdetialData = childref.current.onSubmitDataInput();
          let error = false;
          let errorMessage = { ...eventErrorFormData };
          if (eventdetialData.event_name === '') {
            error = true;
            errorMessage['event_name'] = 'Please enter Event Name';
          } else if (
            eventdetialData.event_name.length < 3 ||
            !/^(?!\s)(?=.*[A-Za-z])[A-Za-z0-9!@#$%^&*()-_+=<>?\s]*$/.test(
              eventdetialData.event_name
            )
          ) {
            error = true;
            errorMessage['event_name'] = 'Please enter proper Event Name';
          } else if (eventdetialData.event_name.length > 500) {
            error = true;
            errorMessage['event_name'] =
              'Please enter Event Name less than 500 characters';
          }
          if (eventdetialData.event_name !== '') {
            let eventExist = await checkEventNameAPI(
              eventdetialData.event_name
            );
            if (!eventExist?.data?.data?.data?.exists) {
              error = true;
              errorMessage['event_name'] = 'Event Name already exists';
            }
          }

          if (eventdetialData.from_date === '') {
            error = true;
            errorMessage['from_date'] = 'Please enter Event From Date';
          }
          if (eventdetialData.to_date === '') {
            error = true;
            errorMessage['to_date'] = 'Please enter Event To Date';
          }
          if (
            eventdetialData.other_requirements !== '' &&
            eventdetialData.other_requirements.length > 0 &&
            eventdetialData.other_requirements.length > 5000
          ) {
            error = true;
            errorMessage['other_requirements'] =
              'Please enter Other Requirements less than 5000 characters';
          }
          if (
            eventdetialData.about_event !== '' &&
            eventdetialData.about_event.length > 0 &&
            eventdetialData.about_event.length > 5000
          ) {
            error = true;
            errorMessage['about_event'] =
              'Please enter About Event less than 5000 characters';
          }
          if (
            eventdetialData.event_location !== '' &&
            /https?:\/\//.test(eventdetialData.event_location)
              ? !(
                  /^https?:\/\/(www\.)?google\.com\/maps\/(place\/|\?)/.test(
                    eventdetialData.event_location
                  ) ||
                  /^https?:\/\/maps\.app\.goo\.gl\/[A-Za-z0-9]+$/.test(
                    eventdetialData.event_location
                  ) ||
                  /^https:\/\/www\.google\.com\/search\?q=[^&]+(&[^#]*)?(#.+)?$/.test(
                    eventdetialData.event_location
                  )
                )
              : !/^[^<>~"`{}\\]*$/.test(eventdetialData.event_location)
          ) {
            error = true;
            errorMessage['event_location'] =
              'Please enter proper Event Location';
          }
          if (
            eventdetialData.event_location !== '' &&
            !/https?:\/\//.test(eventdetialData.event_location) &&
            eventdetialData.event_location.length > 10
          ) {
            error = true;
            errorMessage['event_location'] =
              'Please enter Event Location less than 500 characters';
          }
          if (error) {
            setErrorEventFormData(errorMessage);
            toaster('Please enter proper data', 'error', 'error');
            return;
          }
          MobileWindow && childRef.current.scrollToTop();
          scrollToTop();
          let data = { ...eventFormData };
          Object.keys(eventdetialData).map((key) => {
            data[key] = eventdetialData[key];
          });
          setEventFormData(data);
        }

        if (currentEventStep === 2 && eventFormData?.employee.length > 0) {
          if (eventFormData?.employee?.[0]?.lastModified) {
            let postData = new FormData();
            postData.append('file', eventFormData?.employee?.[0]);
            let res = await checkValidAttendeesUpload(postData);
            if (res.error) {
              toaster(res.message, 'error', 'error');
              return;
            }
          }
        }

        handleEventStepChange(currentEventStep + 1);
      }
      if (type === 'back') {
        MobileWindow && childRef.current.scrollToTop();
        scrollToTop();
        if (currentEventStep === 1) {
          let stepData = childref.current.onSubmitDataInput();
          let data = { ...eventFormData };
          Object.keys(stepData).map((key) => {
            data[key] = stepData[key];
          });
          setEventFormData(data);
        }
        handleEventStepChange(currentEventStep - 1);
      }
    }
  };

  const getAgencies = async () => {
    if (activeTab !== 'packages' && activeTab !== 'meet') {
      let res = await getBlockedTravelPartners(activeTab);
      if (res.error) {
        toaster(res.message, 'error', 'error');
        return;
      } else {
        let agency = [];
        res.data.data.data.map((item) => {
          agency.push({
            id: item._id,
            value: item._id,
            label: item.agency,
            emailId: item?.contactDetails?.map(
              (contact) => contact?.emailId[0]
            ),
            blocked: item.blocked
          });
        });
        if (activeTab === 'event') {
          setEventAgency(agency);
        }
        if (activeTab === 'mice') {
          setMiceAgency(agency);
        }
      }
    }
  };

  const getModalHeader = () => {
    if (activeTab === 'mice') {
      return 'Create MICE Request';
    }
    if (activeTab === 'event') {
      return 'Create Event Request';
    }
  };

  const getModalBody = () => {
    if (!hasPermission('RAISE_REQUEST')) {
      return (
        <VStack
          alignItems={'center'}
          space={1}
          pt={7}
        >
          <Svg
            width='248'
            height='165'
            viewBox='0 0 248 165'
          >
            {contactAdminSVG}
          </Svg>
          {/* <Text
           fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
           fontWeight={COMMONFONTWEIGHT.LARGE_FONT_WEIGHT}
           color={COLORS.ACCORDION_TITLE_COLOR}
           pt={3}
         >
           Contact Admin!
         </Text> */}
          <Text
            fontSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
            fontWeight={COMMONFONTWEIGHT.SMALL_FONT_WEIGHT}
            color={COLORS.BLACK_COLOR}
          >
            Only Initiator can raise the request!
          </Text>
        </VStack>
      );
    }
    if (activeTab === 'mice') {
      return (
        <>
          <ProgressStepsBar
            steps={totalSteps}
            currentStep={currentMiceStep}
            stepNames={stepNames}
          />
          <Spacer size={10}></Spacer>
          {currentMiceStep === 0 && Object.keys(miceFormData).length > 0 && (
            <MiceBasicDetails
              miceFormData={miceFormData}
              setMiceFormData={setMiceFormData}
              miceErrorFormData={miceErrorFormData}
              setDefaultErrorFrom={setDefaultErrorFrom}
              miceAgency={miceAgency}
              forceRemount={forceRemount}
              childref={childref}
              ref={childref}
              showModal={showModal}
              showToaster={showToaster}
            />
          )}
          {currentMiceStep === 1 && Object.keys(miceFormData).length > 0 && (
            <MiceDetails
              miceFormData={miceFormData}
              setMiceFormData={setMiceFormData}
              miceErrorFormData={miceErrorFormData}
              setDefaultErrorFrom={setDefaultErrorFrom}
              forceRemount={forceRemount}
              childref={childref}
              ref={childref}
              showModal={showModal}
            />
          )}
          {currentMiceStep === 2 && Object.keys(miceFormData).length > 0 && (
            <UploadPeople
              data={miceFormData}
              setData={setMiceFormData}
              forceRemount={forceRemount}
            />
          )}
          {currentMiceStep === 3 && Object.keys(miceFormData).length > 0 && (
            <Attachments
              data={miceFormData}
              setData={setMiceFormData}
              forceRemount={forceRemount}
            />
          )}
        </>
      );
    }
    if (activeTab === 'event') {
      return (
        <>
          <ProgressStepsBar
            steps={totalSteps}
            currentStep={currentEventStep}
            stepNames={stepNames}
          />
          <Spacer size={10}></Spacer>
          {currentEventStep === 0 && Object.keys(eventFormData).length > 0 && (
            <EventBasicDetails
              eventFormData={eventFormData}
              setEventFormData={setEventFormData}
              eventErrorFormData={eventErrorFormData}
              setDefaultErrorFrom={setDefaultErrorFrom}
              eventAgency={eventAgency}
              forceRemount={forceRemount}
              childref={childref}
              ref={childref}
              showModal={showModal}
              showToaster={showToaster}
            />
          )}
          {currentEventStep === 1 && Object.keys(eventFormData).length > 0 && (
            <EventDetails
              eventFormData={eventFormData}
              setEventFormData={setEventFormData}
              eventErrorFormData={eventErrorFormData}
              setDefaultErrorFrom={setDefaultErrorFrom}
              forceRemount={forceRemount}
              childref={childref}
              ref={childref}
              showModal={showModal}
            />
          )}
          {currentEventStep === 2 && Object.keys(miceFormData).length > 0 && (
            <UploadPeople
              data={eventFormData}
              setData={setEventFormData}
              forceRemount={forceRemount}
            />
          )}
          {currentEventStep === 3 && Object.keys(miceFormData).length > 0 && (
            <Attachments
              data={eventFormData}
              setData={setEventFormData}
              forceRemount={forceRemount}
            />
          )}
        </>
      );
    }
  };

  const getModalFooter = () => {
    if (!hasPermission('RAISE_REQUEST')) {
      return (
        <Box mx={MobileWindow && 'auto'}>
          <CustomButton
            onPress={() => {
              closeModal();
            }}
            text='Okay'
            color={COLORS.WHITE_COLOR}
          />
        </Box>
      );
    }

    return (
      <>
        {((activeTab === 'mice' && currentMiceStep === 0) ||
          (activeTab === 'event' && currentEventStep === 0)) && (
          <Box width={MobileWindow && '100%'}>
            <CustomButton
              onPress={() => handleSteps('next')}
              text='Next'
              color={COLORS.WHITE_COLOR}
            />
          </Box>
        )}
        {((activeTab === 'mice' &&
          (currentMiceStep === 1 || currentMiceStep === 2)) ||
          (activeTab === 'event' &&
            (currentEventStep === 1 || currentEventStep === 2))) && (
          <>
            <Box
              width={MobileWindow && '50%'}
              justifyContent={MobileWindow && 'center'}
              alignItems={MobileWindow && 'center'}
            >
              <Text
                onPress={() => handleSteps('back')}
                color={COLORS.MODAL_BACK_BUTTON_COLOR}
                fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
                fontWeight={COMMONFONTWEIGHT.LARGE_FONT_WEIGHT}
                mt={3}
                mr={12}
              >
                Back
              </Text>
            </Box>
            <Box width={MobileWindow && '50%'}>
              <CustomButton
                onPress={() => handleSteps('next')}
                text='Next'
                color={COLORS.WHITE_COLOR}
              />
            </Box>
          </>
        )}
        {((activeTab === 'mice' && currentMiceStep === 3) ||
          (activeTab === 'event' && currentEventStep === 3)) && (
          <>
            <Box
              width={MobileWindow && '50%'}
              justifyContent={MobileWindow && 'center'}
              alignItems={MobileWindow && 'center'}
            >
              <Text
                onPress={() => handleSteps('back')}
                color={COLORS.MODAL_BACK_BUTTON_COLOR}
                fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
                fontWeight={COMMONFONTWEIGHT.LARGE_FONT_WEIGHT}
                mt={3}
                mr={12}
              >
                Back
              </Text>
            </Box>
            <Box width={MobileWindow && '50%'}>
              <CustomButton
                onPress={onCreateRequest}
                text='Submit'
                color={COLORS.WHITE_COLOR}
              />
            </Box>
          </>
        )}
      </>
    );
  };

  const updateDataTabChange = () => {
    setPagination(0);
    setEvents([]);
    setCurrentPage(1);
    setTabActiveButton('upcoming');
    // getEventList("upcoming", 1, 20, "", true);
  };

  return (
    <>
      {!hasPermission('LANDING_PAGE') ? (
        <Box
          bg={COLORS.THEME_BACKGROUND}
          pb={8}
          minHeight={'100vh'}
        >
          {hasPermission('USER_IMAGE_CARD') && activeTab === 'packages' ? (
            <PackagesListingPage
              setEvents={setEvents}
              setPagination={setPagination}
              setCurrentPage={setCurrentPage}
            />
          ) : hasPermission('QUICK_MEET') && activeTab === 'meet' ? (
            <QuickMeetListingPage
              setEvents={setEvents}
              setPagination={setPagination}
              setCurrentPage={setCurrentPage}
              hotelList={hotelList}
            />
          ) : (
            <>
              <Box
                bg={COLORS.WHITE_COLOR}
                pt={2}
                pb={!hasPermission('SHOW_CVENT_BANNER') && 2}
              >
                {!hasPermission('SHOW_CVENT_BANNER') ? (
                  MobileWindow ? (
                    <MobileHeader
                      updateDataTabChange={updateDataTabChange}
                      showTabs={true}
                    />
                  ) : (
                    <WebHeader updateDataTabChange={updateDataTabChange} />
                  )
                ) : MobileWindow ? (
                  <CventMobileLandingPageBanner />
                ) : (
                  <CventWebLandingPageBanner />
                )}
              </Box>
              <VStack
                ml={!MobileWindow && 8}
                mr={!MobileWindow && 8}
                px={MobileWindow ? '25px' : '50px'}
                py='30px'
                space={12}
                minH='100vh'
              >
                {userInfo.role !== 'vendor' ? (
                  <>
                    <LandingPageEvents
                      setEvents={setEvents}
                      pagination={pagination}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      setActiveButton={setTabActiveButton}
                      getEventList={getEventList}
                      workflow={workflow}
                      events={events}
                      loaded={isLoading}
                    />
                    <QuickLinks handleLinksSelect={handleLinksSelect} />
                    <Box
                      alignItems={'center'}
                      mt={3}
                      width={'100%'}
                    >
                      <Box mb={3}>
                        <CommonHeading text='Package' />
                      </Box>
                      <PackagesCard
                        activeButton='package_approved'
                        landingPage={true}
                      />
                    </Box>
                  </>
                ) : (
                  <VendorLandingPageEvents
                    setEvents={setEvents}
                    pagination={pagination}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    setActiveButton={setTabActiveButton}
                    getEventList={getEventList}
                    workflow={workflow}
                    events={events}
                    loaded={isLoading}
                  />
                )}
              </VStack>
            </>
          )}
        </Box>
      ) : !quickLink ? (
        <>
          {!MobileWindow ? (
            <CustomModal
              isOpen={showModal}
              onClose={closeModal}
              header={getModalHeader()}
              body={showModal && getModalBody()}
              footer={getModalFooter()}
              raiseReq={hasPermission('RAISE_REQUEST') && true}
              width={
                MobileWindow
                  ? '100%'
                  : !hasPermission('RAISE_REQUEST')
                  ? '50%'
                  : '70%'
              }
              scrollToTop={scrollToTop}
            />
          ) : (
            <MobileModelSheet
              isOpen={showModal}
              onClose={closeModal}
              header={getModalHeader()}
              body={showModal && getModalBody()}
              footer={getModalFooter()}
              ref={childRef}
              maxH={'80vh'}
            />
          )}
          {hasPermission('PACKAGES_TAB') && activeTab === 'packages' ? (
            <PackagesListingPage
              setEvents={setEvents}
              setPagination={setPagination}
              setCurrentPage={setCurrentPage}
            />
          ) : hasPermission('QUICK_MEET') && activeTab === 'meet' ? (
            <QuickMeetListingPage
              setEvents={setEvents}
              setPagination={setPagination}
              setCurrentPage={setCurrentPage}
              hotelList={hotelList}
            />
          ) : (
            <>
              <Box bg={COLORS.THEME_BACKGROUND}>
                <LandingPageBanner
                  show
                  openModal={openModal}
                />
                <VStack
                  ml={!MobileWindow && 8}
                  mr={!MobileWindow && 8}
                  px={MobileWindow ? '25px' : '50px'}
                  py='30px'
                  space={12}
                  minH={'60vh'}
                >
                  {userInfo.role !== 'vendor' ? (
                    <LandingPageEvents
                      setEvents={setEvents}
                      pagination={pagination}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      setActiveButton={setTabActiveButton}
                      getEventList={getEventList}
                      workflow={workflow}
                      events={events}
                      loaded={isLoading}
                    />
                  ) : (
                    <VendorLandingPageEvents
                      setEvents={setEvents}
                      pagination={pagination}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      setActiveButton={setTabActiveButton}
                      getEventList={getEventList}
                      workflow={workflow}
                      events={events}
                      loaded={isLoading}
                    />
                  )}
                  <QuickLinks handleLinksSelect={handleLinksSelect} />
                  <VStack
                    space={5}
                    width={'100%'}
                  >
                    <Box
                      alignItems={'center'}
                      width={'100%'}
                    >
                      <Box mb={3}>
                        <CommonHeading text='Package' />
                      </Box>
                      <PackagesCard
                        activeButton='package_approved'
                        landingPage={true}
                      />
                    </Box>
                  </VStack>
                </VStack>
              </Box>
            </>
          )}
        </>
      ) : (
        <>
          <QuickLinksDetailsPage
            setQuickLink={setQuickLink}
            selectedLink={selectedLink}
            isEvent={activeTab === 'event' ? true : false}
          />
        </>
      )}
    </>
  );
};

export default LandingPage;
